__turbopack_context__.v({
  "fadeInUp": "_9bp7Ha_fadeInUp",
  "imageAnimation": "_9bp7Ha_imageAnimation",
  "sectionAnimation": "_9bp7Ha_sectionAnimation",
  "textAnimation": "_9bp7Ha_textAnimation",
});
